import { CopilotConversation } from 'models/copilot/copilotConversation';
import { ControlLinkDTO } from 'models/dto/controlLinkDTO';
import { CopilotConversationDTO } from 'models/dto/copilot/copilotConversationDTO';
import ResourceLinkDTO from 'models/dto/resourceLinkDTO';
import ResourceListDTO from 'models/dto/resourceListDTO';
import ResourceLink from 'models/resourceLink';
import ResourceList from 'models/resourceList';

export class TenantProcessStateLibrary {
  public conversation: CopilotConversation;

  public links: ResourceLink[];

  public lists: ResourceList[];

  public controlLinks: ControlLinkDTO[];

  constructor() {
    this.conversation = new CopilotConversation();
    this.links = [];
    this.lists = [];
    this.controlLinks = [];
  }
}

export class TenantProcessStateLibraryDTO {
  public conversation: CopilotConversationDTO;

  public links: ResourceLinkDTO[];

  public lists: ResourceListDTO[];

  public controlLinks: ControlLinkDTO[];

  constructor() {
    this.conversation = new CopilotConversationDTO();
    this.links = [];
    this.lists = [];
    this.controlLinks = [];
  }
}
